import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import Auth from './Auth';
import { LocaleProvider } from '../i18n';
import { ClassNamesProvider } from '../uiClassNames';
import { ConfigProvider } from '../config';

var Widget = function Widget(_a) {
  var _a$lang = _a.lang,
      lang = _a$lang === void 0 ? 'ru' : _a$lang,
      uiSettings = _a.uiSettings,
      _a$config = _a.config,
      config = _a$config === void 0 ? {} : _a$config,
      props = __rest(_a, ["lang", "uiSettings", "config"]);

  return _jsx(ClassNamesProvider, Object.assign({
    classNames: uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.classNames
  }, {
    children: _jsx(LocaleProvider, Object.assign({
      lang: lang
    }, {
      children: _jsx(ConfigProvider, Object.assign({
        config: config
      }, {
        children: _jsx(Auth, Object.assign({}, props, {
          uiSettings: uiSettings
        }))
      }))
    }))
  }));
};

export default Widget;